// extracted by mini-css-extract-plugin
export default {"title":"title--D8u3Z","list":"list--BI7f4","listItemLink":"listItemLink--ggxS9","listItem":"listItem--dPBGl","icon":"icon--ti9M-"};